module.exports = __webpack_public_path__ + "media/images/dmu-kaikou-offer0914-a2949000769dd6c628735fef1bf0bdaa.jpg";